// RSK Tours — single source of truth for all Call / WhatsApp CTAs.
// Do NOT swap these constants for other numbers.

export const BUSINESS_WHATSAPP_DIGITS = "916302206106"; // wa.me format (no +)
export const BUSINESS_PHONE_INTL = "+916302206106";     // tel: format
export const BUSINESS_PHONE_DISPLAY = "+91 63022 06106";

export const DEFAULT_WA_MESSAGE =
  "Hi RSK Tours, I would like to book a Hyderabad to Srisailam trip. Please share the available packages, vehicle options and fare details.";

// wa.me works reliably on Android, iOS, desktop and mobile browsers.
export function waHref(message = DEFAULT_WA_MESSAGE) {
  return `https://wa.me/${BUSINESS_WHATSAPP_DIGITS}?text=${encodeURIComponent(message)}`;
}

export const telHref = `tel:${BUSINESS_PHONE_INTL}`;

// Back-compat helpers kept so older imports keep working.
export function buildWhatsAppLink(_ignoredNumber, message = DEFAULT_WA_MESSAGE) {
  return waHref(message);
}

export function tripEnquiryMessage(_agency, _trip) {
  return DEFAULT_WA_MESSAGE;
}
